export default __webpack_public_path__ + "static/media/space.a1026ea4.png";